import { render, staticRenderFns } from "./ShowNotesDialog.vue?vue&type=template&id=159d4acf"
import script from "./ShowNotesDialog.vue?vue&type=script&lang=js"
export * from "./ShowNotesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports